import {Route, Routes, BrowserRouter} from 'react-router-dom';
import {Layout} from "../layout/Layout";
import {routes} from "./modules";

export const Router = () => (
  <BrowserRouter future={{v7_startTransition: false, v7_relativeSplatPath: false}}>
    <Routes>
      <Route element={<Layout/>}>
        {routes.map(({path, component: Component}) => (
          <Route
            key={path}
            path={path}
            element={<Component/>}
          />
        ))}
      </Route>
    </Routes>
  </BrowserRouter>
)